module.exports = __webpack_public_path__ + "static/media/serverlogo.ab9a0e15.png";